module.exports = __webpack_public_path__ + "static/media/writesonic_ai.03f88049.png";